<template>
  <v-touch class="row locations" :class="hasPickLocation" @press="orderProductOptions(locationType,product,order)">
    <div class="locations-warehouse col-4"
         :id="'product-barcode-'+product.id">
      <p class="location"><i v-if="product.manualAdjustment" class="fas fa-exclamation mr-5"/> <i
          class="fad fa-warehouse-alt mr-3"/> {{ product.name }}</p>
    </div>
    <div class="col-2 locations-amount" v-if="locationType=='loading'">
      <p>{{ product.amountPicked ? product.amountPicked : 0 }} /
        <strong> {{ product.amountPickable ? product.amountPickable : product.amount }}</strong></p>
    </div>
    <div class="col-2 locations-amount" v-else>
      <p>{{ product.amountUnloaded ? product.amountUnloaded : 0 }} /
        <strong> {{ product.amountPickable ? product.amountPickable : product.amount }}</strong></p>
    </div>
    <div class="col-4 location-product-name">
      <p>{{ getProductInfo }}</p>
    </div>
    <div class="col-1 deviation-present">
      <i v-if="getDeviationsOfOrderProduct(parseInt(order.id), product.id, ['PRESENT_ON_FLOOR'], product.locationId ? [product.locationId] : []).length" @click="showDeviations($event)"
         class="fas fa-exclamation-triangle deviation-present"/>
    </div>
    <div class="col-1 locations-checkbox">
      <i v-if="isFullyPicked" class="fas fa-check-square done"/>
      <i v-if="!isFullyPicked" class="far fa-square not-done"/>
    </div>

    <div class="col-12" v-if="getMeBasic.companyId === 7">
      <span class="pallet-places-amount">PP</span>{{ (product.palletPlaces * product.amount) | roundToOneDecimal }}
    </div>

    <div class="col-12 mt-5" v-if="product.barcodeUnreadable && !isFullyPicked && product.name">
      <button @click="barcodeScanned(product.productNumber)" class="btn btn-success btn-block">
        {{ $t('shopfloor.loadingPage.barcodeUnreadableButton') }}
      </button>
    </div>
    <div class="col-12 mt-5"
         v-if="product.barcodeUnreadable && !isFullyPicked && (product.name  == 'lege pallets' || product.name  == 'Lege europallets')
         && (getMeBasic.companyId === 7 || getMeBasic.companyId === 1)">
      <button @click="barcodeScannedPallets(product)" class="btn btn-legePallet btn-block">
        Laad alle lege pallets
      </button>
    </div>
    <div class="col-12 mt-5" v-if="!this.product.name && this.product.amount > 0">
      <button :disabled="synchronizing" @click="syncStock(product)" class="btn btn-success btn-block">
        {{ $t('shopfloor.loadingPage.syncStock') }}
      </button>
    </div>
  </v-touch>
</template>

<script>
import isMobile from '../../plugins/isMobile';
import {mapGetters} from 'vuex';
import {deviationPopUp} from "@/mixins/deviationPopUp";


export default {
  props: ['product', 'order', 'locationType'],
  mixins: [deviationPopUp],
  data() {
    return {
      synchronizing: false
    };
  },
  computed: {
    ...mapGetters('deviations', ['getDeviationsOfOrderProduct']),
    ...mapGetters('users', [
      'getMeBasic'
    ]),
    getProductInfo() {
      if (this.getMeBasic.companyId === 9) {
        return this.product.productNumber;
      } else {
        return this.product.productName;
      }
    },
    isBuizenkrat() {
      if (this.getMeBasic.companyId === 7) {
        return (this.product.productName.toLowerCase().indexOf('buizenkrat') > -1 || this.product.productName.toLowerCase().indexOf('buizen krat') > -1);
      } else {
        return false
      }
    },
    hasPickLocation() {
      if (this.locationType === 'unloading' && this.product.amountUnloaded == this.product.amount) {
        if (this.isBuizenkrat) {
          return 'buizenkrat-light-blue';
        } else {
          return '';
        }
      }
      if (!this.product.name && this.product.amount > 0) {
        // Overrules buizenkrat blue => so no check
        return 'no-location';
      }
      if (this.isBuizenkrat) {
        return 'buizenkrat-light-blue';
      } else {
        return '';
      }
    },
    isFullyPicked() {
      if (this.product && this.product.amount) {
        let product = this.product;
        let pickable = product.amountPickable ? product.amountPickable : product.amount;
        return product.fullyPicked || pickable <= product.amountPicked;
      } else {
        return false;
      }
    }
  },
  filters: {
    roundToOneDecimal(value) {
      const rounded = Math.round(value * 10) / 10;
      return isNaN(rounded) ? '' : rounded;
    }
  },
  methods: {
    showDeviations(event) {
      event.stopPropagation();
      const deviations = this.getDeviationsOfOrderProduct(parseInt(this.order.id), this.product.id, ['PRESENT_ON_FLOOR'], this.product.locationId ? [this.product.locationId] : []);
      this.showDeviationSwal(deviations);
    },
    isMobile() {
      return isMobile.check();
    },
    async barcodeScannedPallets(product) {
      let loadPallets = await this.$swal({
        title: "Pallets laden?",
        text: "Alle pallets volledig laden?",
        showCancelButton: true
      })
      if (loadPallets.value) {
        let locationId = product.locationId
        let amount = product.amount
        this.$FB.collection('pick-locations').doc(locationId).update({
          manualAdjustment: true,
          amountPicked: amount,
        }).then(() => {
          return this.$swal({
            customClass: {
              header: 'align-items-center'
            },
            toast: true,
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 5000,
            type: 'success',
            title: this.$root.$t('shopfloor.teamlead.loading.saveSuccess')
          });
          // update pick location?
        })
      }
    },
    showSyncDoneToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'success',
        title: this.$t('shopfloor.loadingPage.syncStockDone')
      });
    },
    showSyncFailedToast() {
      this.$swal({
        customClass: {
          header: 'align-items-center'
        },
        toast: true,
        position: 'bottom-end',
        showConfirmButton: false,
        timer: 5000,
        type: 'error',
        title: this.$t('shopfloor.loadingPage.syncStockFailed')
      });
    },
    barcodeScanned(productNumber) {
      this.$SCANNER_CONFIG.barCodeEventBus.$emit('barcodeScanned', productNumber);
      /*     this.$emit('barcodeScanned',productNumber)*/
    },
    async syncStock(product) {
      this.synchronizing = true;
      let token = JSON.parse(localStorage.getItem('motivate-token')).oauthToken;
      try {
        await this.$CLOUD_API.put(`/locations/syncFirebaseStock`, {
          companyId: product.companyId,
          orderProductId: product.id
        }, {
          headers: {
            Authorization: 'Bearer ' + token
          }
        });
        this.synchronizing = false;
        this.showSyncDoneToast();
      } catch (e) {
        console.error(e);
        this.synchronizing = false;
        this.showSyncFailedToast();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.no-location {
  background: rgba(255, 24, 0, 0.17) !important;

  i {
    color: red;
  }

  &:nth-of-type(odd) {
    background: rgba(255, 24, 0, 0.25) !important;
  }
}

.buizenkrat-light-blue {
  background-color: #E7FBFF;
}

.btn-legePallet {
  background: #ffa0a0;
  border: 0;
  color: white;
}
</style>
